import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const UserList = Loadable(lazy(() => import("./UserList")));
const UserForm = Loadable(lazy(() => import("./UserForm")));

const userRoutes = [
  {
    path: "/User/UserList",
    element: <UserList />,
    permission: PERMISSIONS.Users.Menu,
  },
  {
    path: "/User/UserForm",
    element: <UserForm />,
  },
  {
    path: "/User/UserForm/:userId",
    element: <UserForm />,
  },
];
export default userRoutes;
